import { Options, SeriesColumnOptions } from 'highcharts';
import {
  getDefaultChartOptions,
  getDefaultScrollBarOptions,
  getDefaultTooltipOptions,
} from './utils';

const hasOverdueColumn = (seriesName: string) =>
  ['To do', 'In progress', 'Blocked'].includes(seriesName);

const isOverdueSeries = (seriesName: string) => seriesName === 'Overdue';

const getPlacementAttribute = (seriesName: string) =>
  isOverdueSeries(seriesName)
    ? { pointPlacement: 0.2, pointPadding: 0.25 }
    : hasOverdueColumn(seriesName)
    ? { pointPlacement: -0.15, pointPadding: 0.25 }
    : null;

export const getTasksByStatusOptions = (initialOptions?: Options): Options => ({
  ...initialOptions,
  chart: { ...getDefaultChartOptions(), height: initialOptions?.chart?.height },
  tooltip: {
    ...getDefaultTooltipOptions(),
    ...initialOptions?.tooltip,
    headerFormat: '',
  },
  plotOptions: {
    ...initialOptions?.plotOptions,
    series: {
      ...initialOptions?.plotOptions?.series,
      cursor: 'default',
    },
    column: {
      grouping: false,
    },
  },
  title: initialOptions?.title,
  xAxis: initialOptions?.xAxis,
  yAxis: initialOptions?.yAxis,
  series: (initialOptions?.series ?? []).map(
    (data) =>
      ({
        ...data,
        ...getPlacementAttribute(data.name ?? ''),
      } as SeriesColumnOptions),
  ),
  scrollbar: {
    ...initialOptions?.scrollbar,
    ...getDefaultScrollBarOptions(),
  },
});
